// extracted by mini-css-extract-plugin
export default {"head":"TableHead-module__head__hC2ep"};